/**
 * Central route SEO helpers for the Vue SPA.
 * index.html holds the crawlable home shell + JSON-LD; this layer keeps
 * title / description / robots / canonical in sync after client navigation.
 */

const SITE = 'https://coinproof.ai'

const DEFAULTS = {
  title: 'Coinproof | Multi exchange crypto chart scanner and shortlist tool',
  description:
    'From chart idea to a board that watches with you. Strategies, private shapes, shortlists, and match alerts to Telegram, Discord, in-app, or your HTTPS webhook. Free: hourly on one exchange. Pro: about 10 minute refresh. Not trading signals or financial advice.',
  robots: 'index, follow',
  ogImage: `${SITE}/og-share.jpg`,
}

function ensureMeta(attr, key, content) {
  if (typeof document === 'undefined') return
  let el = document.head.querySelector(`meta[${attr}="${key}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function ensureLink(rel, href) {
  if (typeof document === 'undefined') return
  let el = document.head.querySelector(`link[rel="${rel}"]`)
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', rel)
    document.head.appendChild(el)
  }
  el.setAttribute('href', href)
}

/**
 * Apply document SEO from a vue-router route `meta.seo` object.
 * @param {import('vue-router').RouteLocationNormalized} to
 */
export function applyRouteSeo(to) {
  const seo = (to.meta && to.meta.seo) || {}
  const title = seo.title || DEFAULTS.title
  const description = seo.description || DEFAULTS.description
  const robots = seo.robots || DEFAULTS.robots
  const path = to.path === '/' ? '/' : to.path.replace(/\/$/, '') || '/'
  const canonical = seo.canonical || `${SITE}${path === '/' ? '/' : path}`
  const ogImage = seo.ogImage || DEFAULTS.ogImage

  document.title = title

  ensureMeta('name', 'description', description)
  ensureMeta('name', 'robots', robots)
  ensureLink('canonical', canonical)

  ensureMeta('property', 'og:title', title)
  ensureMeta('property', 'og:description', description)
  ensureMeta('property', 'og:url', canonical)
  ensureMeta('property', 'og:image', ogImage)

  ensureMeta('name', 'twitter:title', title)
  ensureMeta('name', 'twitter:description', description)
  ensureMeta('name', 'twitter:image', ogImage)
}

export { SITE, DEFAULTS }
